import { render, staticRenderFns } from "./CustomerOrderList.vue?vue&type=template&id=345fe1fc&scoped=true"
import script from "./CustomerOrderList.vue?vue&type=script&lang=js"
export * from "./CustomerOrderList.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderList.vue?vue&type=style&index=0&id=345fe1fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345fe1fc",
  null
  
)

export default component.exports